import { RootState } from "@/types";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { SiteState } from "@/types/site";
import { Site } from "@/models/site";
import { Pagination } from "@/models/pagination";

import { AmountByCategory } from "@/models/amount_by_category";

const state: SiteState = {
  site: new Site(),
  pagination: new Pagination(),
  amount: 0,
  amount_by_category: new AmountByCategory()
};
export const site: Module<SiteState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
